import React from 'react';
export function SocialProof() {
  return <section className="bg-brand-dark py-8 border-y border-white/5" data-id="element-288">
      <div className="max-w-xl mx-auto px-5" data-id="element-289">
        <p className="text-center text-[10px] font-bold text-blue-400/50 uppercase tracking-[0.2em] mb-6" data-id="element-290">
          CONFIADO POR PROFESIONALES Y ESTUDIANTES
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-291">
          <StatItem value="+5,000" label="FAMILIAS YA LO ESTÁN USANDO" data-id="element-292" />
          <StatItem value="6" label="TOMOS COMPLETOS" data-id="element-293" />
          <StatItem value="4.9/5" label="CALIFICACIÓN ⭐" data-id="element-294" />
          <StatItem value="🌎" label="Argentina y Latinoamérica" isEmoji data-id="element-295" />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-5 pt-4 border-t border-gray-800/50" data-id="element-296">
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-297">
            📄 100% digital (PDF)
          </span>
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-298">
            ⚡ Acceso inmediato
          </span>
          <span className="text-xs md:text-sm text-gray-400 font-medium text-center w-full" data-id="element-299">
            🧠 Para personas y familias que quieren mayor tranquilidad,
            autonomía y preparación real
          </span>
        </div>
      </div>
    </section>;
}
function StatItem({
  value,
  label,
  isEmoji
}: {
  value: string;
  label: string;
  isEmoji?: boolean;
}) {
  return <div className="flex flex-col items-center justify-center py-2" data-id="element-300">
      <div className={`${isEmoji ? 'text-3xl' : 'text-2xl md:text-3xl'} font-black text-brand-yellow mb-1`} data-id="element-301">
        {value}
      </div>
      <div className="text-[10px] md:text-xs text-gray-500 font-semibold uppercase tracking-wider leading-tight" data-id="element-302">
        {label}
      </div>
    </div>;
}